import * as _4 from 'lodash';

interface IRule<C, V> extends IFallbackRule<C, V> {
  condition: (c: C) => boolean;
}

interface IFallbackRule<C, V> {
  value: (c: C) => V;
}

/**
 * ConditionalSwitch
 *
 * @description represents complex, generic logic; replaces `if-else if-else` because it
 */
export class ConditionalSwitch<C, V> {
  constructor(private __rules: IRule<C, V>[], private __fallback: IFallbackRule<C, V>) {}

  evaluate(executionContext: C): V {
    const rule: IRule<C, V> = _4.find(this.__rules, function (_rule: IRule<C, V>) {
      return _rule.condition(executionContext);
    });

    return rule ? rule.value(executionContext) : this.__fallback.value(executionContext);
  }
}

export class ConditionalSwitchSafe<C, V> extends ConditionalSwitch<C, V> {}



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-strategy/src/lib/conditional_switch.ts